import { Lookup } from "projects/shared/src/models/lookup";
import { CheckTypeCategoryEnum } from "../../../shared/models/verification-tasks/enums/CheckTypeCategoryEnum";
import { VerificationTaskStatusEnum } from "../../../shared/models/verification-tasks/enums/VerificationTaskStatusEnum";
import { StoreTypeEnum } from "./enums/StoreTypeEnum"
import { TaskPriorityEnumValues } from 'projects/admin/src/app/shared/models/verification-tasks/enums/TaskPriorityEnumValues';



export class TaskDetails {
  status: Status
  priority: Priority
  taskId: number
  taskNumber: string
  duedate: string
  branch: string
  operatorLogo: string
  city: string
  website: string
  storeType: StoreTypeEnum
  checkTypeCategoryEnum: CheckTypeCategoryEnum
  checkTypeName: string
  ambassadorData: AmbassadorData
  haveAmbassador: boolean
  trackName: string
  creationDate: Date
  updateDate: Date
  approvalDate: Date
  assignedDate: Date
  requestNumber: string
  canViewRequest: boolean
  requestId: number
  modificationReasons: ModificationReason[]
  economicOperatorName: string
  group: string
  instructions: string
  canDelete: boolean
  institution: Lookup
  escalationReason: string
  checkForm: string
  complainceRate: any
  longitude: string
  latitude: string
}

export interface Status {
  title: string
  statusCode: VerificationTaskStatusEnum
}

export interface Priority {
  id: number
  name: string
  code: TaskPriorityEnumValues
  icon: any
}

export interface AmbassadorData {
  name: string
  image: string
}
export interface ModificationReason {
  title: string
  reason: string
  date: string
  status: VerificationTaskStatusEnum
}
